import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tree } from 'antd';
import * as Template from "../../templates";

import * as actions from "../../actions";
import { useLocation } from "react-router-dom";

export default (props) => {
  const moduleName = "product_categories";
  const [rows, setRows] = useState([])
  const [visible, setVisible] = useState(false)
  const [row, setRow] = useState()
  const location = useLocation()

  const appReducer = useSelector((state) => state.appReducer);

  const dispatch = useDispatch();

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName));
  }, []);

  const onSelect = (selectedKeys, info) => {
    setRow(info.node)
    setVisible(true)
  }

  useEffect(() => {
    dispatch(actions.list(moduleName));
    setVisible(false)
    setRow(undefined)
  }, [appReducer.product_categories_destroy]);



  useEffect(() => {
    if (appReducer.product_categories_list != undefined) {
      setRows(appReducer.product_categories_list.data)
    }
  }, [appReducer])

  return <div>
    <div className="  bg-neutral-100 p-3 text-neutral-600 border border-neutral-200 text-sm">برای حذف و ویرایش روی آیتم کلیک کنید</div>
    {visible && <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />}
    <Tree onSelect={onSelect} treeData={rows} />
  </div>;
};
